import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { LocationOn, Phone, Email, AccessTime } from "@mui/icons-material";

export default function ContactPage() {
  const sectionStyle = {
    backgroundColor: "#f7f7f7",
    padding: "40px 20px",
    borderRadius: "16px",
    marginBottom: "30px",
  };

  const headingStyle = {
    color: "#BF0603",
    fontWeight: 700,
    marginBottom: "16px",
    fontFamily: "Quicksand",
  };

  const subHeadingStyle = {
    color: "#f35b04",
    fontWeight: 600,
    marginBottom: "16px",
    fontFamily: "Quicksand",
  };

  const textStyle = {
    color: "#000",
    lineHeight: 1.7,
    fontSize: "16px",
    fontFamily: "Quicksand",
  };

  return (
    <Box sx={{ p: { xs: 2, sm: 4, md: 6 }, maxWidth: "1200px", margin: "100px auto auto auto" }}>

      {/* Page Title */}
      <Typography variant="h4" sx={{ ...headingStyle, textAlign: "center", mb: 4 }}>
        Contact Us
      </Typography>

      {/* Contact Information */}
      <Box sx={sectionStyle}>
        <Typography variant="h6" sx={subHeadingStyle}>
          Get in Touch
        </Typography>
        <Grid container spacing={3} alignItems="stretch">

          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <Card elevation={1} sx={{ borderRadius: "16px", width: "100%" }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <LocationOn sx={{ fontSize: 40, color: "#f35b04" }} />
                <Typography sx={textStyle}>
                  <strong>Office Address:</strong>
                  <br />
                  Vivaha Sangamam
                  <br />
                  No.5/26 58th Street Ashok Nagar
                  <br />
                  (Namma Aachi Kitchen Backside),
                  <br />
                  Chennai - 600078
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <Card elevation={1} sx={{ borderRadius: "16px", width: "100%" }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Phone sx={{ fontSize: 40, color: "#f35b04" }} />
                <Typography sx={textStyle}>
                  <strong>Contact Person:</strong> V. Shankar Ganesh
                  <br />
                  +91 9962008680
                  <br />
                  +91 8903791212
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4} sx={{ display: "flex" }}>
            <Card elevation={1} sx={{ borderRadius: "16px", width: "100%" }}>
              <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                <Email sx={{ fontSize: 40, color: "#f35b04" }} />
                <Typography sx={textStyle}>
                  <strong>Email:</strong>
                  <br />
                  vivahasangamam10@gmail.com
                </Typography>
              </CardContent>
            </Card>
          </Grid>

        </Grid>
      </Box>

      {/* Business Hours */}
      <Box sx={sectionStyle}>
        <Typography variant="h6" sx={subHeadingStyle}>
          Business Hours
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <AccessTime sx={{ fontSize: 40, color: "#f35b04", flexShrink: 0 }} />
          <Typography sx={textStyle}>
            <strong>Monday – Sunday: 9:30 AM to 6:30 PM</strong>
            <br />
            (Open All 365 Days)
          </Typography>
        </Box>
      </Box>

      {/* Map Section */}
      <Box sx={{ ...sectionStyle, padding: 0, overflow: "hidden" }}>
        <Box sx={{ width: "100%", height: "400px", borderRadius: "16px", overflow: "hidden" }}>
          <iframe
            title="Vivaha Sangamam Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.02767981779!2d80.2169505!3d13.0339093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa878b304e18473f7%3A0x4e27de59aa48831d!2sVivaha%20Sangamam!5e0!3m2!1sen!2sin!4v1763637839987!5m2!1sen!2sin"
            style={{ border: 0, width: "100%", height: "100%" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>
      </Box>

    </Box>
  );
}
